import { render, staticRenderFns } from "./DisciplineSheet.vue?vue&type=template&id=4ecb7680&scoped=true"
import script from "./DisciplineSheet.vue?vue&type=script&lang=js"
export * from "./DisciplineSheet.vue?vue&type=script&lang=js"
import style0 from "./DisciplineSheet.vue?vue&type=style&index=0&id=4ecb7680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecb7680",
  null
  
)

export default component.exports